/**
 * Created by Jaehyun on 2018-05-14.
 */
//util functions
import 'nodelist-foreach-polyfill';

const w = window;
const apiInfo = {
    dev : 'dev-burrardroofing.com',
    live : 'burrardroofing.com'
};
const env = (w.location.origin.indexOf('dev-') > -1
            || w.location.origin.indexOf('localhost') > -1
            || w.location.origin.indexOf('192.168.0') > -1) ? 'dev' : 'live';

/**
 *
 * @param val string. id of element
 */
let $ = function(val){

    if(typeof val !== 'object' && typeof val !== 'string') {
        console.log('not allowed', val)
        this.ele = [];
        return false;
    }else {
        this.ele = (typeof val === 'string') ? document.querySelectorAll(val) : [val];
    }

    //return this.ele;
};

$.prototype.addClass = function(val){
    let element, name, arr;
    element = this.ele;
    name = val;
    if(element && element.length > 0){
        arr = element[0].className.split(" ");
        if (arr.indexOf(name) === -1) {
            element[0].className += " " + name;
        }
    }
    return this;
};

$.prototype.removeClass = function(val){
    let element, name, arr;
    element = this.ele;
    name = val;
    if(element && element.length > 0){
        arr = element[0].className.split(" ");
        if (arr.indexOf(name) > -1) {
            arr.splice(arr.indexOf(name), 1);
            element[0].className = arr.join(' ');
        }
    }
    return this;
};

$.prototype.hasClass = function(val){
    let element, name, arr;
    element = this.ele;
    name = val;
    if(element && element.length > 0){
        arr = element[0].className.split(" ");
        return (arr.indexOf(name) > -1);
    }
}

/**
 *
 * @param topNav string. id
 * @param spyOn string. body default. element to track scroll position
 *
 * @param obj object. body default. element to track scroll position
 *
 */
const scrollSpy = (obj) => {
    w.onload = () => {

        let element = (obj.spyOn) ? new $(obj.spyOn).ele[0] : (document.body || document.documentElement);
        const ele = new $(obj.navWrapper);
        console.log('list', ele.ele[0], ele.ele[0].querySelectorAll(obj.menuClass), obj.active)
        const links = ele.ele[0].querySelectorAll(obj.menuClass);
        let contentArr = [];
        let menuParentArr = [];
        let cnt = 0;
        let activeIdx = (typeof obj.active === 'number') ? obj.active : null;
        let prevActiveIdx = null;
        let baseURI = document.baseURI, prevBaseURI = '';

        links.forEach(function (currentValue, currentIndex, listObj) {
            let href = links[currentIndex].getAttribute('href');

                setArr(currentValue, currentIndex);
                cnt++;

                //activeIdx = currentIndex;
                //link event; scroll to each anchored content
                links[currentIndex].addEventListener('click', (e) => {
                    console.log('clicked', e, contentArr[currentIndex]);
                    activeIdx = currentIndex;
                    setTimeout(function(){
                        let href = links[currentIndex].getAttribute('href');
                        //let conId = (href.indexOf('#') > -1) ? href.substr(href.indexOf('#'), href.length) : href;
                        let conId = (href.indexOf('#') > -1) ? href.substr(href.indexOf('#'), href.length) : '#'+currentValue.getAttribute('id');
                        //remove query params

                        let conEle = new $(conId);
                        let menuEle = new $(conEle.ele[0].parentElement);

                        if(links[currentIndex].getAttribute('data-isspyon') === 'true'){

                            let scrollY = conEle.ele[0].offsetTop;

                            (element.scrollTo) ? element.scrollTo(0, scrollY) : element.scrollTop = scrollY;
                            console.log('scroll', scrollY)

                        }else {

                            (element.scrollTo) ? element.scrollTo(0, 0) : element.scrollTop = 0;
                        }


                        prevActiveIdx = activeIdx;
                    }, 0)

                });
        });

        console.log('links', links, contentArr, obj.active);

        element.addEventListener('scroll', (e) => {
            //console.log('scroll', e, element.scrollY);

            setTimeout(addClass(e), 0);

        });

        function setArr(ele, idx){
            let href = links[idx].getAttribute('href');
            //let conId = (href.indexOf('#') > -1) ? href.substr(href.indexOf('#'), href.length) : href;
            let conId = (href.indexOf('#') > -1) ? href.substr(href.indexOf('#'), href.length) : '#'+ele.id.substr(2);  //remove 'm-'
            //remove query params
            contentArr.push(new $(conId));
            menuParentArr.push(new $(ele.parentElement));
        }

        /**
         *
         * @param e event.
         */
        function addClass(e){
            let scrollY = (element.pageYOffset) ? element.pageYOffset : element.scrollTop;
            //console.log(scrollY);
            //console.log(contentArr);
            //console.log(menuParentArr);

            //nav
            if(scrollY === 0){
                //$topNav
                ele.addClass('on');
            }else{
                ele.removeClass('on');
            }

            baseURI = (e) ? e.currentTarget.baseURI : document.baseURI; //document.baseURI;
            //console.log('baseURI', baseURI, prevBaseURI);

            if((baseURI !== prevBaseURI) && (baseURI && baseURI.indexOf('#') === -1)){
                contentArr = [];
                menuParentArr = [];
                links.forEach(function (currentValue, currentIndex, listObj) {
                    setArr(currentValue, currentIndex);
                });
            }

            cnt = 0;
            links.forEach(function (currentValue, currentIndex, listObj) {
                cnt++;
                let href = links[currentIndex].getAttribute('href');
                //remove query params

                //let conId = (href.indexOf('#') > -1) ? href.substr(href.indexOf('#'), href.length) : href;
                //let id =
                let isMain = (links[currentIndex].getAttribute('data-isspyon') === 'true')
                let eleId = (isMain) ? currentValue.id.substr(2) : currentValue.id
                let conId = (href.indexOf('#') > -1) ? href.substr(href.indexOf('#'), href.length) : '#'+eleId;

                let conEle = new $(conId); //contentArr[currentIndex];
                let menuEle = new $(currentValue.parentElement);

                //menus for main page
                if(conEle.ele.length > 0 && isMain){

                    let nextOffTop = conEle.ele[0].offsetTop + conEle.ele[0].offsetHeight;
                    //console.log('nextOffTop', nextOffTop, contentArr)
                    if(contentArr[(currentIndex+1)] ) {
                        if (contentArr[(currentIndex+1)].ele.length > 0) {
                            //console.log('add', conEle.ele[0].getAttribute('id'), contentArr[(currentIndex + 1)].ele[0]);
                            nextOffTop = contentArr[(currentIndex+1)].ele[0].offsetTop
                        }
                    }

                    //console.log(currentIndex, scrollY, conEle.ele[0].offsetTop, nextOffTop)

                    //console.log(currentIndex, conEle.ele[0].getAttribute('id'), scrollY, conEle.ele[0].offsetTop, nextOffTop)
                    if(conEle.ele[0] && (scrollY >= conEle.ele[0].offsetTop) && (scrollY < nextOffTop)){

                        menuEle.addClass(obj.activeClass);
                        conEle.addClass(obj.activeClass);

                    }else {
                        conEle.removeClass(obj.activeClass);
                        menuEle.removeClass(obj.activeClass);
                    }

                //menus for not main pages
                }else {


                    if(conEle.ele[0] && ( currentIndex === activeIdx )){

                        menuEle.addClass(obj.activeClass);
                        conEle.addClass(obj.activeClass);

                    }else {
                        conEle.removeClass(obj.activeClass);
                        menuEle.removeClass(obj.activeClass);
                    }

                }

                //prevActiveIdx = activeIdx;
                if(cnt == listObj.length){
                    prevBaseURI = baseURI;
                }

            });
        }
        addClass();
    }
};

const windowload = () => {

}

const onScroll = (callback) => {
    w.onload = () => {
        document.addEventListener('scroll', (e) => {
            if(callback) callback(e)
        })
        if(callback) callback(null)
    }
}

const getUrlParameter = (val) => {
    let _url = decodeURIComponent(w.location.search.substring(1)),
        urlVars = _url.split("&"),
        paramsKey;

    for (let i = 0; i < urlVars.length; i++) {
        paramsKey = urlVars[i].split("=");

        if (paramsKey[0] === val) {
            return paramsKey[1] === undefined ? false : paramsKey[1];
        }
    }
};

const getApiUrl = () =>{
    return apiInfo[env];
};

//scroll to top
const scrollToTop = (e) => {
    if(e) e.preventDefault();
    //w.scrollTo(0, 0);
    //let $ele = new $('#index').ele[0];
    (w.scrollTo) ? w.scrollTo(0,0) : w.scrollTop = 0;
}

const apiCall = (url, data, options) => {

    //var req, type;
    let req, header = {};
    //formName for form
    if(data.formId){
        req = new FormData(document.getElementById(data.formId));
        //console.log('data.files', data.files);
        /*if(data.files){
            for(var i in data.files){
                console.log('append file', data.files[i]);
                req.append('file', data.files[i]);
            }
        }*/
        //header['content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        //header['content-type'] = 'multipart/form-data';
    }else {
        req = JSON.stringify(data);
        //type = 'application/json';
    }

    let optObj = {
        body: req, // must match 'Content-Type' header
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        //credentials: 'same-origin', // include, same-origin, *omit
        /*headers: new Headers({
            //    'user-agent': 'Mozilla/4.0 MDN Example',
            //    'accept' : type,
            //    'content-type': type,
        }),*/
        headers : new Headers(header),
        method: (options.method) ? options.method : 'GET', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, cors, *same-origin
        //redirect: 'follow', // manual, *follow, error
        //referrer: 'no-referrer', // *client, no-referrer
    }

    return fetch('//'+getApiUrl()+'/api/'+url, optObj)
        .then((response) => {
            if (!response.ok) {
                //todo : test json format
                throw Error(response.statusText);
            }
            return response.json()
        }) // parses response to JSON

};

const escapeHtml = (unsafe) => {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
};

const decodeHtml = (str) => {
    let ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
};

const Util = {
    escapeHtml : escapeHtml
    ,decodeHtml : decodeHtml
    ,getUrlParameter : getUrlParameter
    ,getApiUrl : getApiUrl
    ,apiCall : apiCall
    ,scrollSpy : scrollSpy
    ,scrollToTop : scrollToTop
    ,windowOnload : windowload
    ,onScroll : onScroll
    ,$ : $
};

export default Util;


// WEBPACK FOOTER //
// ./src/utils.js